<template>
    <button type="submit" class="vfb-submit" :class="classes"
            :disabled="disabled"
            :aria-busy="disabled ? 'true' : undefined">
        {{ text }}
    </button>
</template>

<script setup lang="ts">

interface Props {
    text: string,
    alignButton?: string,
    color?: string,
    classes?: string,
    // Gesperrt, solange eine Absendung läuft — verhindert Mehrfach-Submits.
    disabled?: boolean
}

withDefaults(defineProps<Props>(), {
    text: 'Send',
    color: 'primary',
    classes: 'btn btn-primary w-100',
    disabled: false
});

</script>
